import _ from 'lodash'

function defaultConfig(binding) {
  let config = _.assign({
    // container: 'body'
  }, binding.value || {})

  return config
}

function configure(config, el) {
  const templateId = window.$(el).attr('data-popover-template-id')
  if (undefined !== templateId) {
    let template = _.get(window.$(`#${templateId}`), 0)
    if (template && template.innerHTML) {
      config.content = template.innerHTML
    }
  }

  return config
}

export default {
  inserted(el, binding) {
    if (!window.$) {
      return
    }

    let config = defaultConfig(binding)

    config = configure(config, el)

    window.$(el).popover(config)
  },
  update(el, binding) {
    if (!window.$) {
      return
    }

    let config = defaultConfig(binding)

    config = configure(config, el)

    window.$(el).popover(config)
  },
  unbind(el) {
    if (!window.$) {
      return
    }

    window.$(el).popover('destroy')
  }
}
